import {ComponentProps, useEffect, useState} from "react";
import {Button, Col, Form, Input, Modal, ModalProps, Row, Select as AntSelect, Space} from "antd";
import {useForm} from "antd/lib/form/Form";
import CategoryCascader from "../../../../components/CategoryCascader";
import * as api from "../../../../apis/productCategory";
import {useRequest} from "ahooks";
import DatePicker from "../../../../components/DatePicker";
import Upload from "../../../../components/Upload";

type ProductDetailModalProps = ModalProps & {record?:any} & { onCancel: Function };

function ProductDetailModal(props: ProductDetailModalProps) {
    const {record, ...otherProps} = props;
    const [form] = useForm();
    const [categories, setCategories] = useState([]);
    const {loading: loadingCategory, run: getCategory} = useRequest(api.getCategoriesDict, {
        manual: false,
        onSuccess(res) {
            setCategories(res.data.data);
        }
    })

    useEffect(() => {
        form.setFieldsValue(record||{});
    }, [record]);
    return <Modal open={!!record} width={800} title={'商品详情'} {...otherProps} destroyOnClose footer={<Space><Button onClick={props.onCancel as any}>关闭</Button></Space>}>
        <Form form={form} disabled={true} layout={"horizontal"}>
            <br/>
            <Row gutter={12}>
                <Col span={12}>
                    <Form.Item name={'code'} label={'商品编码'}>
                        <Input/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'name'} label={'商品名称'}>
                        <Input/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'categoryId'} label={'产品线'}>
                        <CategoryCascader options={categories} fieldNames={{label: "name", children: "children", value: "id"}}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'specification'} label={'规格'}>
                        <Input/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'unit'} label={'计量单位'}>
                        <Input/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'registeredName'} label={'注册名称'}>
                        <Input/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'abbreviation'} label={'英文缩写'}>
                        <Input/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'rate'} label={'税率'}>
                        <Input suffix={'%'}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'licenseCode'} label={'生产许可证编号'}>
                        <Input/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'standardCode'} label={'生产标准编号'}>
                        <Input/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'certificateCode'} label={'注册证编码'}>
                        <Input/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'certificateValidity'} label={'注册证有效期'}>
                        <DatePicker/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'companyName'} label={'所属公司'}>
                        <Input/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'status'} label={'状态'}>
                        <AntSelect options={[{value:false,label:'停用'}, {value:true, label:'启用'}]}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'capacity'} label={'容量'}>
                        <Input suffix={'ml'}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'unitWeight'} label={'单位重量'}>
                        <Input suffix={'g'}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'image'} label={'商品图片'}>
                        <Upload listType={'picture-card'} maxCount={1}>
                            <br/>
                        </Upload>
                    </Form.Item>
                </Col>

            </Row>
        </Form>
    </Modal>
}

export default ProductDetailModal;